import type { UserListApiRecord, UserRecord, UserTypeValue } from "../../../types/users";

const accessTypeLabels: Record<UserTypeValue, string> = {
  0: "Sales Rep",
  1: "Administrator",
  2: "Customer",
};

export function normalizeUserRecord(user: UserListApiRecord): UserRecord {
  const { type } = user;

  if (typeof type !== "number") {
    return { ...user, type };
  }

  return {
    ...user,
    type: {
      value: type,
      label: accessTypeLabels[type],
    },
  };
}
